import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0003',
    ecrans: ['00-2'],
    params: ['pruseq', '?vaesysnatctb', '?indcleint', '?t_prucleint', '?vaeprutypbdg', '?annfindeb']
});
